<template>
	<div class="container">
		<!-- 头部 -->
		<div class="row justify-content-start top">
			<div class="col-4">
				<img class="img-fluid" :src="appLogo">
			</div>
			<div class="col-8">
				<h3 class="top-title">{{appName}}
					<span class="top-title-spec" @click="viewCourse()">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
							class="bi bi-question-circle-fill" viewBox="0 0 16 16">
							<path
								d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" />
						</svg>
						<span>安装教程</span>
					</span>
				</h3>
				<div class="top-btn">
					<button type="button" @click="install()" class="btn btn-primary btn-lg">免费安装</button>
				</div>
			</div>
		</div>
		<!-- 评分 -->
		<div>
			<div class="row align-items-start grade">
				<div class="col grade-item">
					<div>1.8万个评分</div>
					<div class="grade-item-title">5.0</div>
					<div>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
					</div>
				</div>
				<div class="col grade-item">
					<div>年龄</div>
					<div class="grade-item-title">18+</div>
					<div>&nbsp;</div>
				</div>
				<div class="col grade-item">
					<div>排行榜</div>
					<div class="grade-item-title">#1</div>
					<div>应用</div>
				</div>
				<div class="col grade-item" style="border-right: 0px;">
					<div>大小</div>
					<div class="grade-item-title">102.02</div>
					<div>MB</div>
				</div>
			</div>
			<div>
				<div class="version">
					<div class="row align-items-start">
						<div class="col version-title">
							新功能
						</div>
						<div class="col version-date">
							<span>版本</span>
						</div>
					</div>
					<div class="row">
						<div class="col version-desc">
							版本1.0.0
						</div>
						<div class="col version-desc" style="text-align: right;">
							2022-11-16 13:45
						</div>
					</div>
				</div>
			</div>
			<div class="supplier">
				<div class="supplier-title">供应商</div>
				<div class="version-desc">Apple Developer</div>
			</div>
			<div class="score">
				<div class="score-title">评分及评论</div>
				<div class="row">
					<div class="col-4 score-index">4.9</div>
					<div class="col-8 score-star">
						<div class="row fushu">
							<div class="col-5 score-star-svg">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
							</div>
							<div class="col-6 line">
								<p class="line-95"></p>
							</div>
							<div class="col-1"></div>
						</div>
						<div class="row fushu">
							<div class="col-5 score-star-svg">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
							</div>
							<div class="col-6 line">
								<p class="line-20"></p>
							</div>
							<div class="col-1"></div>
						</div>
						<div class="row fushu">
							<div class="col-5 score-star-svg">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
							</div>
							<div class="col-6 line">
								<p class="line-10"></p>
							</div>
							<div class="col-1"></div>
						</div>
						<div class="row fushu">
							<div class="col-5 score-star-svg">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
							</div>
							<div class="col-6 line">
								<p class="line-5"></p>
							</div>
							<div class="col-1"></div>
						</div>
						<div class="row fushu">
							<div class="col-5 score-star-svg">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
									class="bi bi-star-fill" viewBox="0 0 16 16">
									<path
										d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
								</svg>
							</div>
							<div class="col-6 line">
								<p class="line-2"></p>
							</div>
							<div class="col-1"></div>
						</div>
					</div>
				</div>
				<div class="row score-footer">
					<div class="col-4">满分5分</div>
					<div class="col-8">1.88 万</div>
				</div>
				<div class="comment">
					<div class="comment-title">
						ლ(′◉❥◉｀ლ)^-^
					</div>
					<div class="comment-star">
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
					</div>
					<div class="comment-desc">
						这个应用真的太好用了，应用流畅不卡顿，画面清晰，操作便捷，玩法丰富多样，同事都在玩这个App，朋友们可以试试看，真的是非常的不错，强烈推荐推荐推荐！！！
					</div>
				</div>
				<div class="comment">
					<div class="comment-title">
						9527^-^
					</div>
					<div class="comment-star">
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor"
							class="bi bi-star-fill" viewBox="0 0 16 16">
							<path
								d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
						</svg>
					</div>
					<div class="comment-desc">
						这个应用真的太好用了，应用流畅不卡顿，画面清晰，操作便捷，玩法丰富多样，同事都在玩这个App，朋友们可以试试看，真的是非常的不错，强烈推荐推荐推荐！！！
					</div>
				</div>
			</div>
			<div class="mianze">
				免责声明：本网站仅为开发者提供App的下载和安装托管，App内的内容和运营相关事项由App开发者负责，与本网站无关。
			</div>
		</div>
		
		
		<div class="offcanvas offcanvas-bottom" tabindex="-1" :class="showProgress ? 'show' : ''" id="offcanvasBottom"
			aria-labelledby="offcanvasBottomLabel">
			<div class="offcanvas-header">
				<h6 class="offcanvas-title" id="offcanvasBottomLabel">APP安装指南</h6>
				<button type="button" @click="closeDownload()" class="btn-close" data-bs-dismiss="offcanvas"
					aria-label="Close"></button>
			</div>
			<div class="offcanvas-body small">
				<div :class="download_progress">
					<div class="progress">
						<div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
							:aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="width"></div>
					</div>
					<div class="allow_desc" style="text-align: left;">APP下载安装中，请耐心等待！</div>
					<div>
						<button type="button" @click="viewCourse()" class="btn btn-link">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
								class="bi bi-chevron-double-up" viewBox="0 0 16 16">
								<path fill-rule="evenodd"
									d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708l6-6z" />
								<path fill-rule="evenodd"
									d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
							</svg>
							&nbsp;点击查看安装教学
						</button>
					</div>
				</div>
				<div :class="showTrust">
					<div class="allow_title">下载完成</div>
					<div class="allow_desc">立即点击一键信任按钮完成设定</div>
					<button type="button" @click="allowIos()" class="btn btn-primary allow_btn">一键信任</button>
				</div>
			</div>
		</div>
		
		
		<div class="offcanvas offcanvas-bottom offcanvas_zhiyin" :class="showCourse ? 'show' : ''" tabindex="-10"
			id="offcanvasBottom2" aria-labelledby="offcanvasBottomLabel">
			<div class="offcanvas-header">
				<h6 class="offcanvas-title">安装教学指南</h6>
				<button type="button" @click="closeCourse()" class="btn-close" data-bs-dismiss="offcanvas"
					aria-label="Close"></button>
			</div>
			<div class="offcanvas-body small">
				<img class="img-fluid" src="../assets/zhiyin.png">
			</div>
		</div>
		
	</div>
</template>

<script>
	import useClipboard from 'vue-clipboard3'
	const {
		toClipboard
	} = useClipboard(); //复制
	export default {
		components: {
		},
		computed: {
		},
		data() {
			return {
				online: gconf.online,
				download: {
					ios: "",
					spareIos: "",
					android: "",
				},
				showProgress: false, //显示进度条
				showCourse: false, //显示教程
				showTrust: "hideArea", //显示一键信任
				progress: 0,
				width: 'width:0%;',
				maxtime: 100,
				timer: null,
				download_progress: 'showArea', //显示下载进度
				selectedBrand: "", //选择的品牌包
				selChannelCode: "", //选中的渠道码
				channelCode: "", //渠道码
				bdTjId: "", //百度统计ID
				appName:'z7体育',//app名字
				appLogo:'',//applogo
			}
		},
		watch: {
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (!flag) {
				if (!this.$route.params.channel) {
					this.$router.push('/home');
				} else {
					this.$router.push('/home/' + this.$route.params.channel);
				}
				return;
			}
			this.appLogo = gconf.appLogo;
			this.appName = gconf.appName;
		},
		methods: {
			customerService() {
				window.location.href = this.online;
			},
			// 下载app
			install() {
				const u = navigator.userAgent;
				const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				if (isiOS) { // IOS 
					this.ios();
				} else { // android
					this.android();
				}
			},
			android() { //下载安卓
				window.location.href = gconf.download.android;
			},
			ios() {
				let iosUrl = gconf.download.ios;
				if(iosUrl.indexOf(".plist") < 0){
					window.location.href = iosUrl;
					return;
				}
				// 采用企业签|webclip
				this.showProgress = true; //显示下载进度
				this.download_progress = true;
				var _domain = "itms-services://?action=download-manifest&url=" + iosUrl;
				var _time1, _time2;
				const that = this;
				setTimeout(function() {
					setInterval(function() {
						that.timer = that.countdown();
					}, 50);
				}, 100);
				window.location.href = _domain;
			},
			countdown() {
				if (this.maxtime >= 0) {
					--this.maxtime;
					this.progress++;
					this.width = "width:" + this.progress + "%;";
				} else {
					clearInterval(this.timer);
					this.showTrust = 'showArea';
					this.download_progress = 'hideArea';
				}
			},
			closeDownload() { //关闭安装进度
				this.showProgress = false;
			},
			viewCourse() { //查看教学
				this.showCourse = true;
			},
			closeCourse() { //关闭教学
				this.showCourse = false;
			},
			allowIos() { //一键信任
				window.location.href = "../embedded.mobileprovision";
			},
		}
	}
</script>


<style scoped>
	.top {
		margin: 10px;
	}

	.top .col-4 img {
		height: 120px;
	}

	.top-title {
		margin-top: 1rem;
		margin-left: 0.6rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-family: PingFangSC-Medium;
		margin-bottom: 1rem;
		font-weight: 700;
		text-align: left;
	}

	.top-title-spec {
		float: right;
		font-size: 12px;
		color: #0d6efd;
		font-weight: normal;
	}

	.top-title-spec svg {
		width: 20px;
		height: 20px;
		margin-right: 2px;
		font-weight: normal;
	}

	.top-btn {
		text-align: left;
		margin-left: 0.6rem;
		margin-top: 26px;
	}

	.btn-lg {
		padding: 4px 10px;
		font-size: 12px;
		width: 7rem;
		border-radius: 20px;
	}

	.grade {
		color: #8e8e93;
		margin: 6px;
		border: 1px solid #eee;
		border-left: none;
		border-right: none;
	}

	.grade-item {
		border-right: 1px solid #e7e7e7;
		margin: 10px 0px;
		font-size: 12px;

	}

	.grade-item div {
		margin: 6px 0px;
	}

	.grade-item svg {
		width: 10px;
		height: 10px;
		margin-right: 2px;
	}

	.grade-item-title {
		font-weight: 700;
	}

	.version {
		margin-top: 1.4rem;
		text-align: left;
	}

	.version-title {
		font-size: 1rem;
		color: #121212;
		font-weight: bold;
	}

	.version-date {
		text-align: right;
		color: #0d6efd;
		font-size: 0.8rem;
	}

	.version-desc {
		font-size: 0.9rem;
		color: #8c8c8e;
		margin-top: 0.4rem;
	}

	.supplier,
	.score,
	.news {
		border-top: 1px solid #e7e7e7;
		margin: 20px 10px;
		text-align: left;
		padding-top: 20px;
		font-size: 1rem;
	}

	.supplier-title,
	.news-title {
		color: #121212;
		font-weight: bold;
	}

	.score-title {
		color: #121212;
		font-weight: bold;
	}

	.score-index {
		font-size: 4rem;
		color: #4B4A4E;
		text-align: center;
	}

	.score-star svg {
		margin-right: 2px;
		color: #999;
		width: 10px;
		height: 10px;
		font-weight: normal;
	}

	.score-star-svg {
		text-align: right;
	}

	.line {
		background-color: #EEEEEE;
		border: 2px solid #EEEEEE;
		display: inline-block;
		margin-top: 0.8rem;
		margin-left: -8px;
		height: 0px;
	}

	.line-95 {
		width: 95%;
		background-color: #232323;
		border: 1px solid #232323;
	}

	.line-20 {
		width: 20%;
		background-color: #232323;
		border: 1px solid #232323;
	}

	.line-10 {
		width: 10%;
		background-color: #232323;
		border: 1px solid #232323;
	}

	.line-5 {
		width: 5%;
		background-color: #232323;
		border: 1px solid #232323;
	}

	.line-2 {
		width: 2%;
		background-color: #232323;
		border: 1px solid #232323;
	}

	.fushu {
		margin-top: -6px;
	}

	.score-footer {
		font-size: 0.32rem;
		color: #999999;
		text-align: center;
	}

	.comment {
		width: 100%;
		margin: auto;
		background-color: #f3f2f8;
		border-radius: 0.12rem;
		margin-top: 1rem;
		margin-bottom: 1rem;
		padding: 10px;
	}

	.comment-star {
		color: orangered;
		margin-top: -10px;
	}

	.comment-star svg {
		margin-right: 3px;
	}

	.comment-desc {
		font-size: 0.4rem;
		color: #333333;
		margin-top: 0.246666rem;
		text-align: justify;
	}

	.mianze {
		margin: 20px 0px;
		padding: 20px;
		font-size: 12px;
		text-align: left;
	}
	
	.offcanvas {
		border-radius: 30px;
		height: 15rem;
	}
	
	.hideArea {
		display: none;
	}
	
	.showArea {
		display: block;
	}
	
	.allow_title {
		color: rgba(51, 51, 51, var(--tw-text-opacity));
		font-weight: 600;
		font-size: 20px;
	}
	
	.allow_desc {
		font-size: 12px;
		color: rgba(153, 153, 153, var(--tw-text-opacity));
	}
	
	.allow_btn {
		margin-top: 2rem;
		width: 10rem;
	}
	
	.offcanvas_zhiyin {
		height: 40rem;
	}
	
	.offcanvas-body {
		margin-top: 0.6rem;
	}
	
	.hidden {
		display: none;
	}
</style>
